/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class GeneratedCsvImportService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation importAuctionStartingBidCsv
   */
  static readonly ImportAuctionStartingBidCsvPath = '/api/csv-import/auction-starting-bids';

  /**
   * Imports a list of starting bids per lot for a given auction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importAuctionStartingBidCsv()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  importAuctionStartingBidCsv$Response(params: {
    auctionId: number;
    'X-API-Version'?: string;
    body?: {
'csv': string;
}
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedCsvImportService.ImportAuctionStartingBidCsvPath, 'post');
    if (params) {
      rb.query('auctionId', params.auctionId, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Imports a list of starting bids per lot for a given auction.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importAuctionStartingBidCsv$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  importAuctionStartingBidCsv(params: {
    auctionId: number;
    'X-API-Version'?: string;
    body?: {
'csv': string;
}
  },
  context?: HttpContext

): Observable<void> {

    return this.importAuctionStartingBidCsv$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation importLotsCsv
   */
  static readonly ImportLotsCsvPath = '/api/csv-import/lots';

  /**
   * Imports a list of lots for a given auction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importLotsCsv()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  importLotsCsv$Response(params: {
    auctionId: number;
    'X-API-Version'?: string;
    body?: {
'csv': string;
}
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedCsvImportService.ImportLotsCsvPath, 'post');
    if (params) {
      rb.query('auctionId', params.auctionId, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Imports a list of lots for a given auction.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importLotsCsv$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  importLotsCsv(params: {
    auctionId: number;
    'X-API-Version'?: string;
    body?: {
'csv': string;
}
  },
  context?: HttpContext

): Observable<void> {

    return this.importLotsCsv$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
